/**
 * Resolves the origin every API request is sent to.
 *
 * Kept in its own module so that the authentication calls and the typed client can both use it
 * without the two importing each other: the client refreshes sessions, and the session code calls
 * the API, which would otherwise be a cycle.
 *
 * @returns an absolute origin: the configured override, otherwise the page origin
 */
export function resolveBaseUrl(): string {
  const configured = import.meta.env.VITE_API_BASE_URL;
  if (configured !== undefined && configured !== '') {
    return configured;
  }
  // Same origin as the page: the dev server and the production reverse proxy both mount the API
  // under /api. An absolute origin (rather than a bare '/') is required because the Fetch Request
  // constructor outside a document context rejects relative URLs.
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'http://localhost:8080';
}
